import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createNegotiation, getEnvelopeSenderList } from "../../../../services/CommonService";
import "../Negotiation.css";
import { toast } from "react-toastify";
import Utils from "../../../../utils";
import {
  CustomDatePicker,
  CustomInput,
} from "../../../../components";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from 'react-select';

const NegotiationStep1 = ({ formObj, setFormObj, setLoading }) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    negotiation_name: "",
    due_date: null,
    // contract_type: "",
    // contract_term: "Definite", 
    // start_date: "",
    // end_date: "",
    // termination_notice_period: "",
    is_renewable: false,
    // purpose_of_disclosure: "",
    // duration_in_months: "",
    // confidential_info_definition: "",
    // exclusions: "",
    // jurisdiction: "",
    envelope_sender_id: 0,
  });

  const [errors, setErrors] = useState({});
  const [senderList, setSenderList] = useState([]);

  useEffect(() => {
    getEnvelopeSenderList()
      .then((response) => {
        const list = response.data.data;
        setSenderList(list);
        if (list.length > 0) {
          setFormData(prev => {
            if (!prev.envelope_sender_id) {
              return { ...prev, envelope_sender_id: list[0].id };
            }
            return prev;
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);


  useEffect(() => {
    if (formObj) {
      setFormData({
        negotiation_name: formObj.negotiation_name || "",
        due_date: formObj.due_date ? new Date(formObj.due_date) : null,
        is_renewable: formObj.is_renewable || false,
        envelope_sender_id: formObj.envelope_sender_id || 0,
      });
    }
  }, [formObj]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleDateChange = (name, date) => {
    setFormData((prev) => ({ ...prev, [name]: date }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const getInitials = (firstName, lastName) => {
    if (!firstName && !lastName) return "";
    return ((firstName ? firstName[0] : "") + (lastName ? lastName[0] : "")).toUpperCase();
  };

  const validateForm = () => {
    const tempErrors = {};
    if (!formData.negotiation_name.trim())
      tempErrors.negotiation_name = "Negotiation name is required.";
    // if (!formData.due_date) tempErrors.due_date = "Due date is required."; 

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e, saveOnly = false) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      negotiation_name: formData.negotiation_name,
      due_date: formData.due_date ? formData.due_date.toISOString().split("T")[0] : null,
      is_renewable: formData.is_renewable ? "Yes" : "No",
      sender_id: formData.envelope_sender_id,
      contract_term: null,
      start_date: null,
      end_date: null,
      termination_notice_period: null,
      purpose_of_disclosure: null,
      duration_in_months: null,
      confidential_info_definition: null,
      exclusions: null,
      jurisdiction: null,
      save_only: saveOnly,
      id: formObj?.negotiation_id || null,
    };

    try {
      setLoading(true);
      let response;
      if (formObj?.negotiation_id && formObj?.negotiation_uuid) {
        const updatePayload = { ...payload, id: formObj.negotiation_id };
        response = await createNegotiation(updatePayload);
        setFormObj((prev) => ({ ...prev, ...formData }));
      } else {
        response = await createNegotiation(payload);
        const resData = response?.data?.data;
        if (!resData?.id || !resData?.uuid) throw new Error("Invalid server response.");
        setFormObj((prev) => ({ ...prev, negotiation_id: resData.id, negotiation_uuid: resData.uuid, ...formData }));
      }

      if (saveOnly) {
        toast.success(response?.data?.message);
        navigate("/client-portal/negotiation-contract");
      } else {
        toast.success(response?.data?.message);
        navigate(`/client-portal/negotiation-contract/create/${formObj?.negotiation_uuid || response?.data?.data?.uuid}/2`);
      }
    } catch (err) {
      toast.error(Utils.getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const onBack = () => navigate("/client-portal/negotiation-contract");

  const renderLabel = (text, tooltipText, isRequired = false) => (
    <span>
      {text}
      <OverlayTrigger
        placement="right"
        overlay={<Tooltip className="custom-tooltip">{tooltipText}</Tooltip>}
      >
        <i className="bi bi-info-circle ms-1 text-muted cursor-pointer" aria-hidden="true" />
      </OverlayTrigger>
    </span>
  );

  const senderOptions = senderList.map(item => ({
    value: Number(item.id),
    label: `${item.first_name} ${item.last_name} (${item.email})`,
    data: item,
  }));
  const selectedSenderOption = senderOptions.find(opt => opt.value === Number(formData.envelope_sender_id)) || null;


  return (
    <div className="negotiation-container section-bg-color">
      <div className="negotiation">
        <div className="negotiation-step1-header">
          <div className="negotiation-header-left">
            <h2 className="step1-title">New Negotiation</h2>
          </div>
          <div className="negotiation-header-right">
            <span className="step-indicator">Step 1 of 6</span>
          </div>
        </div>
        <div className="sleeve-main-card">
          <form onSubmit={(e) => handleSubmit(e, false)} noValidate>
            {/* Sender Section */}
            <div className="sleeve-sender-card mb-4">
              <h2 className="sleeve-heading mb-3">
                <span>
                  Your Email Address (Sender)
                  <i
                    className="bi bi-info-circle ms-1 cursor-pointer fs-6"
                    aria-hidden="true"
                    data-toggle="tooltip"
                    data-placement="left"
                    title="The selected email address will be used to execute the contract signature. Please select from your verified addresses."
                  />
                </span>
              </h2>
              <Select
                classNamePrefix="sleeve-sender-select"
                value={selectedSenderOption}
                onChange={(option) =>
                  setFormData(option ? Number(option.value) : 0)
                }
                options={senderOptions}
                placeholder="Select sender"
                isSearchable={false}
                formatOptionLabel={(option) => (
                  <div className="sleeve-sender-option">
                    <div className="sleeve-sender-initials">
                      {getInitials(option.data.first_name, option.data.last_name)}
                    </div>
                    <div>
                      <div className="sleeve-sender-name">
                        {option.data.first_name} {option.data.last_name}
                      </div>
                      <div className="sleeve-sender-email">
                        {option.data.email}
                      </div>
                    </div>
                  </div>
                )}
                styles={{
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected || state.isFocused ? '#e0e0e0' : 'white',
                    color: 'black',
                    cursor: 'pointer',
                    ':active': {
                      backgroundColor: '#c0c0c0',
                    },
                  }),
                }}
              />
              {errors.sender_id && (
                <div className="error-message">{errors.sender_id}</div>
              )}
            </div>

            <div className="sleeve-sender-card mb-4">
              <div className="row">
                <div className="col-lg-6 mb-4">
                  <CustomInput
                    label={renderLabel("Contract Name", "Enter a unique name to identify this negotiation.", true)}
                    name="negotiation_name"
                    value={formData.negotiation_name}
                    onChange={handleChange}
                    placeholder="Enter Contract name"
                    required
                    error={errors.negotiation_name}
                  />
                </div>

                <div className="col-lg-6 mb-4">
                  <CustomDatePicker
                    label={renderLabel("Due Date", "Set a date by which the collaborator should review and sign the contract. This is optional, but helps set clear expectations.")}
                    name="due_date"
                    selected={formData.due_date}
                    onChange={(date) => handleDateChange("due_date", date)}
                    minDate={new Date()}
                    error={errors.due_date}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <label className="form-label fw-semibold">
                    {renderLabel("Is Contract Renewable", "Indicate if the contract can be renewed after expiry.")}
                  </label>
                  <div className="d-flex align-items-center gap-3 mt-1">
                    <span className={`${!formData.is_renewable ? "fw-bold text-primary" : "text-muted"}`}>No</span>
                    <label className="switch">
                      <input
                        type="checkbox"
                        checked={formData.is_renewable}
                        onChange={handleChange}
                        name="is_renewable"
                      />
                      <span className="slider round"></span>
                    </label>
                    <span className={`${formData.is_renewable ? "fw-bold text-primary" : "text-muted"}`}>Yes</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="sleeve-step-buttons">
              <button className="sleeve-btn-back" onClick={onBack}>Back</button>
              <div className="sleeve-step-buttons-right">
                <button className="sleeve-btn-save" onClick={(e) => handleSubmit(e, true)}>Save & Exit</button>
                <button className="sleeve-btn-next" onClick={(e) => handleSubmit(e, false)}>Next</button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default NegotiationStep1;